import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import { nodeUtils } from '../../../utils/nodeUtils.js';
import CreateForm from '../forms/create-form';
import { createValidationSchema } from '../schema/create';

export default function CreateNode({ data, id, type }) {
  return (
    <NodeProvider
      key={data['data-frame']}
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Create Node Details',
        altText: 'Create Node',
        defaultLabel: nodeUtils.getNodeName(data['data-frame']) || 'Create Node',
        forceDefaultLabel: true,
      }}
    >
      <CommonNode FormComponent={CreateForm} schemaResolver={createValidationSchema} />
    </NodeProvider>
  );
}
